import SquaredBoxSvg228x338 from './SquaredBoxSvg228x338';

export default SquaredBoxSvg228x338;
export { SquaredBoxSvg228x338 };
